import {
  Container,
  Heading,
  Flex,
} from '@chakra-ui/react';
import MainLayout from '@src/components/layouts/main';

import {
  useTceTrafficGroups,
} from '@src/modules/tce/src/context/trafficgroups';

import { councilSelectorEnabledState, lockYearsSelectorEnabledState } from '@transport-insights/uikit';
import { useRcaAccess } from '@tce/context/access';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useSetRecoilState } from 'recoil';
import TrafficGroupTable from './components/TrafficGroupTable';
import MoreDrawer from '../../shared/MoreDrawer';

export default function TrafficGroupPage() {
  const { isLoading, trafficgroups } = useTceTrafficGroups();
  const queryClient = useQueryClient();
  const { data: hasAccess } = useRcaAccess();
  const setEnableCouncilSelector = useSetRecoilState(councilSelectorEnabledState);
  const setEnableLockyearSelector = useSetRecoilState(lockYearsSelectorEnabledState);

  // force refresh on the data on page load
  useEffect(() => {
    queryClient.invalidateQueries('tce-trafficgroups');
  }, [queryClient]);

  useEffect(() => {
    setEnableCouncilSelector(true);
    setEnableLockyearSelector(false);
  }, [setEnableCouncilSelector, setEnableLockyearSelector]);

  useEffect(() => () => {
    setEnableLockyearSelector(true);
  }, [setEnableLockyearSelector]);

  const sortedGroups = trafficgroups?.sort((a, b) => a.code.localeCompare(b.code));

  return (
    <MainLayout>
      <Container maxW="full">
        <Flex align="center" justify="space-between" mb={4}>
          <Heading as="h1">Traffic Groups</Heading>
          <MoreDrawer />
        </Flex>
        {hasAccess === true && (
          <TrafficGroupTable
            trafficGroups={sortedGroups || []}
            isLoading={isLoading}
          />
        )}
      </Container>
    </MainLayout>
  );
}
